import { observer } from 'mobx-react-lite';
import React, { FC, Fragment } from 'react';
import { MultiApp } from '@/config/context';
import { AppLayout } from '@/presentation/layouts';
import { AppSlot } from './components/app-slot';
import { ProAppLayout } from './layouts-pro';

export const MainApp: FC = observer(() => (
    <Fragment>
      <AppSlot apps={[MultiApp.WOA, MultiApp.Internal]}>
        <AppLayout />
      </AppSlot>
      <AppSlot apps={[MultiApp.Pro, MultiApp.Sgp]}>
        <ProAppLayout />
      </AppSlot>
    </Fragment>
));
